import { render, staticRenderFns } from "./ControlIssues.vue?vue&type=template&id=1f92ab03&scoped=true&"
import script from "./ControlIssues.vue?vue&type=script&lang=js&"
export * from "./ControlIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92ab03",
  null
  
)

export default component.exports